var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUpdateAccount(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 18,
    width: 18,
    viewBox: "0.5 1 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 3.25h-3.5A1.75 1.75 0 001.5 5v8.75a1.75 1.75 0 001.75 1.75H12a1.75 1.75 0 001.75-1.75v-3.5m-3.5-8.75h5.25m0 0v5.25m0-5.25l-8.75 8.75",
    stroke: "#2D3748",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default __webpack_public_path__ + "static/media/updateAccount.d9830d15.svg";
export { SvgUpdateAccount as ReactComponent };